/**
 * 用于验证
 */
const fieldsDesc = {
};

module.exports = {

    checkIfNull(data) {
        if (data === null || data === undefined) return true;
        if (typeof data === 'string') {
            return data === '' || data.replaceAll(' ','') === '' || data === 'null' || data.includes('null');
        }
    },

    /**
     * 检查对象是否为空
     * @param {Object} obj 检查对象
     * @param {Array} ignore 忽略字段
     * @returns
     */
    emptyCheckObject: function (obj,ignore = []) {
        return new Promise((resolve,reject) => {
            let res = {
                isPass: true,
                message: ''
            };

            for (let key in obj) {
                let isContains = false;
                for (let index in ignore) {
                    if (ignore[index] === key) {
                        isContains = true;
                        break;
                    }
                }
                if (!isContains) {
                    if (obj[key] == null || obj[key] === '') {
                        let desc = fieldsDesc[key] === null || fieldsDesc[key] === undefined ? key : fieldsDesc[key];
                        res.message += (res.isPass) ? desc : '、' + desc;
                        res.isPass = false
                    }
                }

            }
            res.message += res.isPass === false ? '  不能为空' : '';
            if (!res.isPass) {
                reject(res.message);
            }else {
                resolve(obj);
            }
        })
    },
    // 不可以出现特殊字符: 中文标点和英文标点   如果出现特殊字符 返回true
    checkTitle(title) {
        const chineseSymbols = "，。！？、；：（）";
        const englishSymbols = ",.!?;:+()/";

        for (let i = 0; i < title.length; i++) {
            if (chineseSymbols.includes(title[i]) || englishSymbols.includes(title[i])) {
                return true;
            }
        }
        return false;
    },
    checkPhone(phone) {
        return /^1[3|4|5|6|7|8|9]\d{9}$/.test(Number(phone));
    },
    checkEmail(email) {
        return /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(email)
    },
    // 不能为负、小数点不超过两位
    checkPrice(price) {
        return /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(price);
    },
    checkPositiveInteger(number) {
        return /^[+]{0,1}(\d+)$/.test(Number(number));
    },
    // 正则验证密码，包含数字、大小写字母、特殊字符，长度8-16位
    checkPassword(password) {
        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,16}$/.test(password);
    },
    checkIdentityCode(identityCode) {
        return /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(identityCode) ||
          /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/.test(identityCode);
    },
    checkUrl(url) {
        return /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(url);
    },
    // 查看是否存在中文字符
    checkChineseChar(str) {
        // 使用正则表达式匹配中文字符
        const pattern = /[\u4e00-\u9fa5]/;
        return pattern.test(str);
    },

    // rules
    ruleEmptyStr(message) {
        let check = (rule, value, callback) => {
            if (this.checkIfNull(value)) {
                return callback(new Error(message));
            }else {
                callback();
            }
        };
        return [{validator: check, trigger: "blur"}];
    },
    ruleEmptyArray(message) {
        let check = (rule, value, callback) => {
            if (value == null || value.length === 0) {
                return callback(new Error(message));
            } else {
                callback();
            }
        };
        return [{validator: check, trigger: "blur"}];
    },
    rulePhone() {
        let check = (rule, value, callback) => {
            if (value == null || value === '') {
                return callback(new Error("手机号不能为空"));
            } else if (!this.checkPhone(value)) {
                return callback(new Error("手机号码格式不正确"));
            }
            else {
                callback();
            }
        };
        return [{validator: check, trigger: "blur"}];
    },
    rulePrice() {
        let check = (rule, value, callback) => {
            if (value == null || value === '' || value === 0) {
                return callback(new Error("请填写价格"));
            } else if (!this.checkPrice(value)) {
                return callback(new Error("价格不合法"));
            }
            else {
                callback();
            }
        };
        return [{validator: check, trigger: "blur"}];
    },
    rulePositiveInteger(message) {
        let check = (rule, value, callback) => {
            if (value == null || value === '' || value === 0) {
                return callback(new Error(message));
            } else if (!this.checkPositiveInteger(value)) {
                return callback(new Error(message));
            } else {
                callback();
            }
        };

        return [{ validator: check, trigger: "blur" }];
    },
    ruleUrl() {
        let check = (rule, value, callback) => {
            if (value == null || value === '') {
                return callback(new Error("请填写url"));
            } else if (!this.checkUrl(value)) {
                return callback(new Error("url不合法"));
            }
            else {
                callback();
            }
        };
        return [{validator: check, trigger: "blur"}];
    },
    // 检查英文字符是否合法
    ruleEnglishName() {
        let check = (rule, value, callback) => {
            if (value == null || value === '') {
                return callback(new Error("请填写英文"));
            } else if (this.checkChineseChar(value)) {
                return callback(new Error("存在中文字符"));
            }
            else {
                callback();
            }
        };
        return [{validator: check, trigger: "blur"}];
    },

};